import { http } from "msw";

import { isoNow } from "@/mocks/dates";
import { withSession } from "@/mocks/resolvers";
import { errorResponse, successResponse } from "@/mocks/responses";
import type { PersonaState } from "@/mocks/store";

export type CareplanParams = { careplanId: string };

export const careplanNotFoundResponse = () => {
  return errorResponse({
    status: 404,
    code: "careplan_not_found",
    message: "The requested careplan was not found.",
  });
};

export const findCareplan = (state: PersonaState, careplanId: string) => {
  return state.careplan && String(state.careplan.current.id) === careplanId ? state.careplan : null;
};

export const createCareplanHandlers = (webappUrl: string) => {
  return [
    http.get(
      `${webappUrl}/careplans`,
      withSession(({ state }) => {
        if (!state.careplan) {
          return careplanNotFoundResponse();
        }

        return successResponse(state.careplan, { meta: state.careplanMeta });
      }),
    ),

    http.patch(
      `${webappUrl}/careplans/:careplanId/read`,
      withSession<CareplanParams>(({ params, state }) => {
        const careplan = findCareplan(state, params.careplanId);

        if (!careplan) {
          return careplanNotFoundResponse();
        }

        careplan.current.readAt = careplan.current.readAt ?? isoNow();

        return successResponse({ readAt: careplan.current.readAt });
      }),
    ),
  ];
};
